import { Avatar, Image, Spin } from "antd";
import { useState } from "react";
import useGetSignedImageUrl from "../../hooks/useGetSignedImageUrl";
import "./PersonListImage.css";

type Props = {
  person: any;
  onImageClick?: (person: any) => void;
};

const PersonListImage = ({ person, onImageClick }: Props) => {
  const [isImageLoading, setIsImageLoading] = useState<boolean>(!!person.headImageUrl);
  const { data: signedUrl, isLoading: isSignedUrlLoading } = useGetSignedImageUrl(person.headImageUrl);
  const imageStyles = onImageClick ? { cursor: "pointer" } : {};
  const handleClick = () => onImageClick?.(person);
  const imgSrc = person.headImageUrl === null ? person.dcHeadImageUrl : signedUrl || person.headImageUrl;

  return (
    <div className="image-list-view-image-container">
      {isImageLoading && <Spin size="small" className="spinner" />}
      {imgSrc && !isSignedUrlLoading ? (
        <Image
          style={imageStyles}
          onClick={handleClick}
          preview={false}
          src={imgSrc}
          onLoad={() => setIsImageLoading(false)}
          onError={() => setIsImageLoading(false)}
        />
      ) : (
        <Avatar style={imageStyles} onClick={handleClick} shape="square" icon={<i className="fa-solid fa-user" />} />
      )}
    </div>
  );
};

export default PersonListImage;
